export const STOP_WATCH_NETWORK_STATUS =
  '@@saga-network-status/STOP_WATCH_NETWORK_STATUS';
export const PING_FAILURE = '@@saga-network-status/PING_FAILURE';
export const PING_SUCCESS = '@@saga-network-status/PING_SUCCESS';
export const START_WATCH_NETWORK_STATUS =
  '@@saga-network-status/START_WATCH_NETWORK_STATUS';
